<section class="flex justify-content-center">
  <div class="col-12 px-0">
    <div class="flex flex-column align-items-center gap-3">

      <p-dataView [value]="results" [loading]="isLoading" [paginator]="true"
                  [totalRecords]="totalRecords()" [rows]="rows" [lazyLoadOnInit]="true"
                   [lazy]="true" [first]="first" [styleClass]="styleCustomClass"
                  (onLazyLoad)="onPageHandler($event)"
                  class=" w-full">
        <ng-template pTemplate="header">
          <div class="flex flex-column">
            <h2 class="font-roboto-condensed font-weight-light color-form-label my-2">Se
              Encontraron {{ totalRecords() }} trámites disponibles</h2>
            <div class="search-text">
              <p class="my-0"> En la consulta <span class="text-blue-general">	"{{ text }}"</span>
                en <span class="text-blue-general">  {{ dependencias }}</span></p>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="list" >
          <div class="flex flex-column gap-2">
            @for (item of results; track item.id; let idx = $index) {
              <app-item-tramite-resultado [class]=" idx%2 == 0 ? 'even' : 'odd' "
                                 class="app-border-radius border-0" [text]="text" [index]="idx"
                                  [styleContent]="_typeContent" [item]="item"/>
            }
          </div>
        </ng-template>
        <ng-template pTemplate="empty">
          <div class="flex gap-4 text-orange-400">
            <div class="align-self-start"> <i class="pi pi-exclamation-triangle text-2xl"></i> </div>
            <div class="flex flex-column align-self-start">
              <h3 class="my-0 font-weight-regular">{{ _translations.noHayRegistros }}</h3>
              <p class="text-gray-500 mt-2">{{ _translations.noHayRegistrosDetalle }}</p>
            </div>
          </div>
        </ng-template>
      </p-dataView>
    </div>
  </div>
</section>
